export default __webpack_public_path__ + "static/media/cutting.d0d65f77.jpg";